// src-lit/components/product/kd-product-shipping.ts
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';
import { KdVariantSyncedElement } from './kd-variant-synced-element';

interface ShippingVariantEntry {
  /** 販売期限セクションを表示するか（sales_deadline 設定済み variant） */
  showSalesDeadline: boolean;
  /** snippet v2-product-sales-deadline の事前レンダリング済み HTML。Lit は outerHTML で差し替えるだけ */
  salesDeadlineContentHtml: string;
  /** 発送予定セクションを表示するか（shipping-schedule-text が非 blank の variant） */
  showShippingSchedule: boolean;
  /** snippet v2-product-shipping-schedule の事前レンダリング済み HTML。Lit は outerHTML で差し替えるだけ */
  scheduleContentHtml: string;
}

/**
 * @element kd-product-shipping
 * @description 販売期限・発送予定セクションをバリアント選択に応じて差し替える。
 *   各セクション wrapper の hidden を toggle し、snippet ルートを per-variant スニペット出力で
 *   outerHTML 差し替えする。文字列生成は Liquid 側（snippet）で済ませる方針（二重化禁止）。
 */
@customElement('kd-product-shipping')
export class KdProductShipping extends KdVariantSyncedElement<ShippingVariantEntry> {
  protected readonly variantMapSelector = SELECTORS.PRODUCT_SHIPPING.VARIANT_MAP;

  protected onVariantSelected(entry: ShippingVariantEntry): void {
    this.updateSection(
      SELECTORS.PRODUCT_SHIPPING.SALES_DEADLINE_SECTION,
      SELECTORS.PRODUCT_SHIPPING.SALES_DEADLINE_CONTENT,
      entry.showSalesDeadline,
      entry.salesDeadlineContentHtml,
    );
    this.updateSection(
      SELECTORS.PRODUCT_SHIPPING.SCHEDULE_SECTION,
      SELECTORS.PRODUCT_SHIPPING.SCHEDULE_CONTENT,
      entry.showShippingSchedule,
      entry.scheduleContentHtml,
    );
  }

  private updateSection(
    sectionSelector: string,
    contentSelector: string,
    show: boolean,
    contentHtml: string,
  ): void {
    const section = this.querySelector<HTMLElement>(sectionSelector);
    if (!section) return;

    section.hidden = !show;
    if (!show) return;

    const content = section.querySelector<HTMLElement>(contentSelector);
    // outerHTML で snippet 出力をまるごと置換。置換後の要素も同じ data 属性を持つので次回も querySelector で拾える。
    if (content) content.outerHTML = contentHtml;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-product-shipping': KdProductShipping;
  }
}
